import React from 'react';
import PropTypes from 'prop-types';
import BankruptcyPartiesResultTable from './BankruptcyPartiesResultTable';
import CivilPartiesResultTable from './CivilPartiesResultTable';
import CivilCasesResultTable from './CivilCasesResultTable';
import BankruptcyCasesResultTable from './BankruptcyCasesResultTable';

const resultTables = {
  parties: {
    Bankruptcy: BankruptcyPartiesResultTable,
    Civil: CivilPartiesResultTable,
    Criminal: CivilPartiesResultTable,
    Appellate: CivilPartiesResultTable,
  },
  cases: {
    Bankruptcy: BankruptcyCasesResultTable,
    Civil: CivilCasesResultTable,
    Criminal: CivilCasesResultTable,
    Appellate: CivilCasesResultTable,
  },
};

export const LocalCourtResults = ({ searchResultsType, searchType, data }) => {
  const ResultTable = resultTables[searchResultsType][searchType];

  return (
    <div className="search-results">
      <ResultTable {...{ data, searchType }} />
    </div>
  );
};

LocalCourtResults.propTypes = {
  searchResultsType: PropTypes.string.isRequired,
  data: PropTypes.any.isRequired,
  searchType: PropTypes.string.isRequired,
};

export default LocalCourtResults;



// WEBPACK FOOTER //
// ./src/components/search/localCourtSearch/LocalCourtResults.jsx